import { Brand } from '@blade/std-lib'

export const OAuthStateTypeId = 'tradebot-tma/OAuthState'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OAuthStateTypeId = typeof OAuthStateTypeId

export type OAuthState = Brand.Branded<string, OAuthStateTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OAuthState = Brand.nominal<OAuthState>()
